const DeviceInfo = {
  getUniqueId: async () => 'web-device-id',
  getUniqueIdSync: () => 'web-device-sync',
  getVersion: () => '1.0.0',
  getBuildNumber: () => '1',
  getBundleId: () => 'com.ludovoice.web',
  getSystemName: () => 'Web',
  getSystemVersion: () => (typeof navigator !== 'undefined' ? navigator.userAgent : 'Web'),
  getModel: () => 'Browser',
  getBrand: () => 'Web',
  getDeviceId: () => 'web-client',
  isTablet: () => false,
  hasNotch: () => false,
  getMacAddress: async () => '',
  getIpAddress: async () => '127.0.0.1',
  isLandscape: async () => false,
  isLandscapeSync: () => false,
};

module.exports = DeviceInfo;
module.exports.default = DeviceInfo;
module.exports.isTablet = () => false;
module.exports.getVersion = () => '1.0.0';
module.exports.getUniqueId = async () => 'web-device-id';
module.exports.getUniqueIdSync = () => 'web-device-id';
